<template>
  <div class="jobs-form mt-5">
    <form @submit.prevent="createjobs">

      <h3>Job Create</h3>

      <div class="form-group">
        <label>Name</label>
        <input type="text" class="form-control form-control-lg" v-model="name"/>
      </div>

      <div class="form-group">
        <label>Group Name</label>
        <input type="text" class="form-control form-control-lg" v-model="groupname"/>
      </div>

      <div class="form-group">
        <label>Title</label>
        <input type="text" class="form-control form-control-lg" v-model="title"/>
      </div>
      <div class="form-group">
        <label>Schedule</label>
        <select class="form-control form-control-lg" v-model="frequency">
          <option value="none">No recurring schedule</option>
          <option value="hourly">Every hour</option>
          <option value="daily">Every day at...</option>
        </select>
      </div>
      <div class="form-group" v-if="frequency === 'daily'">
        <label>Time of day</label>
        <input type="time" class="form-control form-control-lg" v-model="dailyTime"/>
      </div>
      <div class="form-group form-check" v-if="frequency !== 'none'">
        <input type="checkbox" class="form-check-input" id="schedulingEnabled" v-model="schedulingEnabled"/>
        <label class="form-check-label" for="schedulingEnabled">Enable scheduled runs</label>
      </div>
      <div class="form-group">
        <label>Type</label>
        <select class="form-control form-control-lg" v-model="type">
          <option value="crawl">crawl</option>
          <option value="monitor">monitor</option>
        </select>
      </div>
      <div class="form-group">
        <label>Tags</label>
        <input type="text" class="form-control form-control-lg" v-model="tags"/>
      </div>
      <div class="form-group">
        <label>Config</label>
        <textarea type="password" class="form-control form-control-lg" v-model="config"/>
      </div>
      <div class="form-group">
        <label>Results</label>
        <textarea type="password" class="form-control form-control-lg" v-model="results" placeholder="null" disabled/>
      </div>

      <button type="submit" class="btn btn-dark btn-lg btn-block mt-2">Create</button>

    </form>
  </div>
</template>

<script>

import axios from "axios";
import statusCheck from "/src/utils/statusCheck.js";
import tokenRefresh from "/src/utils/tokenRefresh.js";
import {buildCronExpression} from "/src/utils/schedule.js";

export default {
  name: 'jobs-list',
  data() {
    return {
      name: '',
      groupname: '',
      title: '',
      type: 'crawl',
      frequency: 'none',
      dailyTime: '00:00',
      schedulingEnabled: false,
      status: '',
      tags: '',
      config: '',
      results: '',
    }
  },
  methods: {
    createjobs: function () {
      const {name, groupname, title, type, tags, config, frequency, dailyTime, schedulingEnabled} = this;
      let encodeConfig = btoa(config);
      const tagsArray = tags ? tags.split(',').map(t => t.trim()).filter(t => t) : [];
      const schedule = buildCronExpression(frequency, dailyTime);
      axios.post(process.env.VUE_APP_CRAWLING_URL + '/api/jobs',
          {
            "name": name,
            "group_name": groupname,
            "title": title,
            "type": type,
            "tags": tagsArray,
            "config": encodeConfig,
            "schedule": schedule,
            "scheduling_enabled": frequency !== 'none' && schedulingEnabled
          }
      )
          .then((response) => {
                if (response.status === 201) {
                  tokenRefresh();
                  this.$router.push({name: "jobs"});
                }
              }
          )
          .catch(function (error) {
                statusCheck(error.response.status);
              }
          )
    }
  }
};
</script>